'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.domicileIndividualFundOptions = exports.domicileOffShoreFund = exports.domicileOnshoreFund = undefined;

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Dictionary = require('./classes/Dictionary');

var _Dictionary2 = _interopRequireDefault(_Dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var domicileOnshoreMap = {
  DELAWARE: 'Delaware',
  WYOMING: 'Wyoming',
  NEVADA: 'Nevada',
  OTHER: 'Other'
};

var domicileOffShoreMap = {
  CAYMAN_ISLANDS: 'Cayman Islands',
  BVI: 'BVI',
  BERMUDA: 'Bermuda',
  LUXEMBOURG: 'Luxembourg',
  SWITZERLAND: 'Switzerland',
  CHANNEL_ISLANDS: 'Channel Islands',
  ISLE_OF_MAN: 'Isle of Man',
  MALTA: 'Malta',
  HONG_KONG: 'Hong Kong',
  SINGAPORE: 'Singapore',
  OTHER: 'Other'
};

var combinedDomicileMap = _extends({}, domicileOnshoreMap, domicileOffShoreMap);

var domicileOnshoreFund = exports.domicileOnshoreFund = new _Dictionary2.default(domicileOnshoreMap);

var domicileOffShoreFund = exports.domicileOffShoreFund = new _Dictionary2.default(domicileOffShoreMap);

var domicileIndividualFundOptions = exports.domicileIndividualFundOptions = new _Dictionary2.default(combinedDomicileMap);